<template>
	<div>
		<el-drawer title="下载二维码" :visible.sync="drawerShow" :wrapperClosable="true" :destroy-on-close="true" size="auto"
			@close="close" v-loading="dataLoading">
			<div class="drawer-content">
				<template v-if="codeData">
					<template v-if="codeData.id">
						<div class="MT20">{{codeData.name}}</div>
						<div class="code">
							<vue-qr :logoSrc="logo" :text="xunyanUrl" :size="800" :logoMargin="8"
								logoBackgroundColor="#ffffff" :callback="getImage" :margin="0"></vue-qr>
							<input class="copyTool" ref="copyTool" :value="xunyanUrl" />
						</div>
						<div class="MT10 textCenter">
							<el-button size="small" plain type="primary"
								@click="$refs.H5Preview.show(xunyanUrl)">直接打开</el-button>
							<el-button type="primary" size="small" @click="copyXunyan">复制链接</el-button>
							<el-button type="primary" size="small" @click="downloadCodeXunyan">下载二维码</el-button>
						</div>
					</template>
				</template>
			</div>
			<div class="drawer-footer">
				<el-button @click="close">关闭</el-button>
			</div>
		</el-drawer>
		<H5Preview ref="H5Preview"></H5Preview>
	</div>
</template>

<script>
	import VueQr from 'vue-qr';
	import logo from '@/assets/img/logo.png';
	import H5Preview from '@/components/H5Preview';

	export default {
		components: {
			VueQr,
			H5Preview
		},
		data() {
			return {
				drawerShow: false,
				codeData: null,
				logo: logo,
				dataLoading: false,
				copyTimer: null,
				sswap: process.env.VUE_APP_SSWAP_URL,
				xunyanUrl: '',
				codeImage: '',
			}
		},
		methods: {
			close() {
				this.drawerShow = false
			},
			show(obj) {
				this.codeData = {
					...obj
				};
				if (this.codeData && this.codeData.id) {
					this.xunyanUrl = this.sswap + '/pages/activity/list/list?type=1&tag=' + this.codeData.id
				}
				this.drawerShow = true
			},

			getImage(url) {
				this.codeImage = url;
			},

			copyXunyan() {
				clearTimeout(this.copyTimer);
				this.copyTimer = setTimeout(() => {
					const e = this.$refs.copyTool;
					e.select();
					document.execCommand("Copy"); // 执行浏览器复制命令
					this.$message.success("链接已复制，可粘贴");
				}, 300)
			},
			downloadCodeXunyan() {
				const _data = this.$utils.base64ToBlob(this.codeImage);
				this.$utils.exportFile(_data, `${this.codeData.name}的巡演二维码.png`);
			},

		}
	}
</script>

<style lang="scss" scoped>
	.drawer-content {
		text-align: center;

		.name {
			font-size: 14px;
			line-height: 20px;
		}

		.code {
			width: 200px;
			height: 200px;
			margin: 15px auto;
			img {
				width: 100%;
				max-width: 100%;
			}
		}
	}
	.copyTool{
		opacity: 0;
		filter: alpha(opacity=0);
		// height: 1px;
	}

	
	
	
</style>